import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, FormGroup, Modal, ModalBody } from "reactstrap";
import SvgImage from "../../../Icons/Icons";
import * as Yup from "yup";
import {
  downloadSalaryAction,
  downloadSalaryCreditSheet,
  uploadSalaryAction,
  uploadSalaryCreditSheet,
} from "../../../../services/Store/Actions/driverslistActions";
import { toast } from "react-toastify";
import {
  bulkTransferUpload,
  bulkWithdrawlUpload,
  downloadBulkTransferAction,
} from "../../../../services/Store/Actions/walletAction";
import { FormCheck } from "react-bootstrap";
// import ShowExcel from "../ShowExcel";
import PinInput from "react-pin-input";
import { uplaodTollTxn } from "../../../../services/Store/Actions/fleetActions";
import "./index.css";
import ViewBankStatment from "../../../Bank/SubComppnents/viewBankStatement";
import { bulkVendorSample, getAllBank, uploadBankStatementExcel, viewBankStatement } from "../../../../services/Store/Actions/TripsAction";

const validationSchema = Yup.object().shape({
  amount: Yup.string()
    .required("Required")
    .matches(/^[0-9]$/, "amount must be a number"),
});
function BulkFuelAllVendors(props) {
  const {
    open,
    onHide,
    toggleModal,
    handleClose,
    vendorData,
    onSubmit,
    mode,
    setMode,
    remarks,
  } = props;
  const [fileSave, setFileSave] = useState(null);
  const [loader, setLoader] = useState(false);
  const [bulkTransfer, setBulkTransfer] = useState(0);
  const [bankName, setBankName] = useState(null);
  const [bankId, setBankId] = useState(null);
  const [viewStatement, setViewStatement] = useState(null);

  const [isWithdraw, setIsWithdraw] = useState(false);
  const [pin, setPin] = useState("");
  const dispatch = useDispatch();
  const customId1 = "custom-id-download page";
  const notify1 = () =>
    toast.success("Template was downloaded successfully.", {
      toastId: customId1,
      pauseOnHover: false,
    });
  const customId2 = "custom-id-upload page";
  const notify2 = () =>
    toast.success("Transfer Sheet uploaded successfully.", {
      toastId: customId2,
      pauseOnHover: false,
    });
  const customId3 = "custom-id-Salary-dispersed";
  const notify3 = () =>
    toast.success("Amount dispersed successfully to drivers.", {
      toastId: customId3,
      pauseOnHover: false,
    });
  const notify4 = () =>
    toast.success("Transfers create successfully", {
      toastId: customId3,
      pauseOnHover: false,
    });
    const downloadSalDisbursement = () => {
      dispatch(bulkVendorSample((res) => {
          console.log("downloadSalaryAction", res?.data)
          if (res?.status == 200) {
              window.open(res?.data?.data?.url)
          }
        }))
  }
  const [modal, setModal] = useState(false);

  const showModalAddDriver = () => {
    setModal(true);
  };

  const bulkTransferCall = () => {
    console.log("njnoeinr", fileSave);
    setLoader(true);
    dispatch(
      uploadBankStatementExcel({ file: fileSave }, (res) => {
        console.log("bjbjbhis",res);
        setLoader(false);
        if (res.status == 200) {
          // const blob = new Blob([res?.data]);
          // const link = document.createElement("a");
          // link.href = window.URL.createObjectURL(blob);
          // link.download = `responseFile.xls`; //name to changed here
          // link.click();
          dispatch(
            viewBankStatement({
              offset: 0,
              limit: 10,
              bankId: props.bankId,
              //   from : from,
              //   to : to,
              //   transferType : tripType == "0" ? "credit" : tripType == "1" ? "debit" : "",
              // startTime: moment(startDate).format("MM/DD/YYYY"),
              // endTime: moment(endDate).format("MM/DD/YYYY"),
              // search: search,
              // status: status,
            })
          );
          dispatch(getAllBank());

          notify4();
        } else {
          toast.error(res.data?.message || "some error occured");
        }
      })
    );
  };
  return (
    <Modal
      isOpen={open}
      onHide={onHide}
      toggle={toggleModal}
      className="Bank-Txn-Modal settingModalMargin"
      aria-labelledby="myModalLabel2"
    >
      <>
        <div style={{ width: "auto" }}>
          <div>
            <div className="row">
              <div
                className="col-lg-4"
                style={{ padding: "20px" }}
                onClick={downloadSalDisbursement}
              >
                <div
                  className="svgContainerUp"
                  style={{ margin: "0 23px", textAlign: "center" }}
                >
                  <SvgImage name="Download" />
                </div>
                <div className="Bold300" style={{ textAlign: "center" }}>
                  Download Template
                </div>
              </div>
              <div className="col-lg-4" style={{ padding: "20px" }}>
                {bulkTransfer == 1 ? (
                  <div
                    className="svgContainerUp"
                    style={{
                      backgroundColor: bulkTransfer > 0 ? "antiquewhite" : null,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div style={{ margin: ".5rem" }}>
                      <a disabled={true}>
                        {fileSave?.name?.length > 10
                          ? fileSave?.name?.substring(0, 10)
                          : fileSave?.name}
                        {}
                      </a>
                      <div
                        className="col-12"
                        style={{
                          marginTop: "5px",
                          textAlign: "center",
                          textDecoration: "underline",
                          color: "blue",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setBulkTransfer(0);
                        }}
                      >
                        <text>Remove</text>
                      </div>
                    </div>
                    {/* <ShowExcel
        toggle={toggleModal}
        modal={modal}
        setModal={setModal}
        fileSave={fileSave}
      /> */}
                    {/* <div>
                      <Button
                        className="greenButton"
                        style={{ margin: ".5rem" }}
                        onClick={bulkTransferCall}
                        disabled={loader}
                      >
                        {" "}
                        Transfer
                      </Button>
                    </div> */}
                  </div>
                ) : (
                  <label for="file-upload2" class="custom-file-upload3">
                    <input
                      id="file-upload2"
                      type="file"
                      onChange={async (e) => {
                        const img = e?.target.files[0];
                        setFileSave(img);
                        console.log("image...", e?.target.files[0]);
                        setBulkTransfer(1);
                        notify2();
                      }}
                    />
                    <div
                      className="svgContainerUp"
                      style={{
                        margin: "0px 23px",
                        textAlign: "center",
                        backgroundColor:
                          bulkTransfer > 0 ? "antiquewhite" : null,
                      }}
                    >
                      <SvgImage name="Upload" />
                    </div>
                    <div className="Bold300" style={{ textAlign: "center" }}>
                      Upload Bank Statement
                    </div>
                  </label>
                )}
              </div>
              <div
                className="col-lg-4"
                style={{ padding: "20px" }}
                onClick={downloadSalDisbursement}
              >
                <div
                  className="svgContainerUp"
                  style={{ margin: "0 23px", textAlign: "center" }}
                >
                                  <SvgImage name="viewInvoices" width="62px" height="62px" />
                                  </div>
                <div className="Bold300" style={{ textAlign: "center" }}>
                  View Records
                </div>
              </div>

              {bulkTransfer == 1 ? (
                <>
                  <div style={{ textAlign: "center" }}>
                    <Button
                      className="greenButton"
                      style={{ margin: ".5rem" }}
                      onClick={bulkTransferCall}
                      disabled={loader}
                    >
                      {" "}
                      Transfer
                    </Button>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        {viewStatement ? (
          <ViewBankStatment
            toggle={() => {
              setViewStatement(!viewStatement);
            }}
            modal={viewStatement}
            setModal={setViewStatement}
          />
        ) : (
          <></>
        )}
      </>
    </Modal>
  );
}

export default BulkFuelAllVendors;
